<template>
    <section class="hero page__section home_screen vidget_wrap blackBack">
        <div class="hero_back">
            <div class="hero_layer" data-layer="1"></div>
            <div class="hero_layer" data-layer="2"></div>
            <div class="hero_layer" data-layer="3"></div>
        </div>
        <div class="hero_content_wrap detectMobVisibility">
            <h2 class="hero__h1 hide_mobi" v-html="$t('home.title')"></h2>
            <h2 class="hero__h1 mobi" v-html="$t('home.title_mob')"></h2>
            <div class="home_button_holder">
                <a v-on:click="onToggleActive" :class="{ 'active-btn': isActiveBtn }" class="button home_button_holder__btn">
                    <span class="button__text">{{ $t('buttons.request') }} →</span>
                </a>
                <div :class="{ 'active-btn': !isActiveBtn }" class="home_button_holder__wrap">
                    <a :href="'mailto:' + requestMailto" class="home_button_holder__wrap-btn">
                        <img src="~@/assets/images/svg/mail.svg" alt="icon-mail" />
                    </a>
                    <a :href="requestTelegram" class="home_button_holder__wrap-btn">
                        <img src="~@/assets/images/svg/telegram.svg" alt="icon-telegram" />
                    </a>
                    <a :href="requestFacebook" class="home_button_holder__wrap-btn">
                        <img src="~@/assets/images/svg/fb.svg" alt="icon-facebook" />
                    </a>
                </div>
            </div>
        </div>
        <div class="hero__scroll-down">{{ $t('home.scroll_down') }} →</div>
    </section>
</template>

<script>
    import params from '../../public/site_config.json'
    
    export default {
        data() {
            return {
                isActiveBtn: false,
                requestMailto: params.reauest_quote_emailto,
                requestTelegram: params.reauest_quote_telegram,
                requestFacebook: params.reauest_quote_facebook
            }
        },
        methods: {
            onToggleActive: function() {
                this.isActiveBtn = !this.isActiveBtn;
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @keyframes move_axisY
        0%
            transform translateY(0%)
        25%
            transform translateY(-1%)
        50%
            transform translateY(-2%)
        75%
            transform translateY(-1%)
        100%
            transform translateY(0%)
            
    @keyframes move_axisX
        0%
            transform translateX(0%)
        25%
            transform translateX(-1%)
        50%
            transform translateX(-2%)
        75%
            transform translateX(-1%)
        100%
            transform translateX(0%)
    
    .hero_back
        width 100%
        height 100%
        position absolute
        top 0
        left 0
        z-index 1
    
    .hero_content_wrap
        position relative
        z-index 2
    
    .hero_layer
        width 100%
        height 100%
        position absolute
        top 0
        left 0
        -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
        transition all .3s cubic-bezier(.25,.01,.25,1)
        
        &[data-layer="1"]
            background url('../assets/images/svg/layer_one.svg') 100% 50% no-repeat
            background-size auto 100%
            z-index 1
            
        &[data-layer="2"]
            background url('../assets/images/svg/layer_two.svg') 100% 50% no-repeat
            background-size auto 100%
            z-index 2
            
        &[data-layer="3"]
            background url('../assets/images/svg/layer_three.svg') 100% 50% no-repeat
            background-size auto 100%
            z-index 3
    
    .section.active .hero_layer
        &[data-layer="1"]
            animation move_axisY 3s infinite linear
            
        &[data-layer="2"]
            animation move_axisX 4s infinite linear
            
        &[data-layer="3"]
            animation move_axisY 5s infinite linear
    
    .home_screen
        display flex
        flex-direction column
        justify-content center
    
    .home_button_holder
        padding-top 40px
        position relative
        transition all .3s cubic-bezier(.25,.01,.25,1)

        .button
            cursor pointer
    
        .home_button_holder__btn,
        .home_button_holder__wrap
            z-index 2

            @media (max-width 1023px)
                margin-left 30px
        

        .home_button_holder__wrap
            padding-top 40px
            position absolute
            top 0
            left 0
            transition all .3s cubic-bezier(.25,.01,.25,1)

            .home_button_holder__wrap-btn
                width: 76px
                height: 50px
                border-radius: 25px
                display inline-flex
                justify-content center
                align-items center
                background: #2858a2

            .home_button_holder__wrap-btn:not(:last-child)
                margin-right 30px

    .hero_content_wrap.detectMobVisibility .home_button_holder .active-btn
        opacity 0
        z-index 1
    
    
    
    .hero
        background #222
        color #fff

    .hero__h1
        font-size 40px
        line-height 1.2
        font-weight bold
        margin-bottom 40px
        
        @media (min-width 420px)
            font-size 48px
        
        @media (min-width 700px)
            max-width 550px

        @media (min-width 1024px)
            font-size 64px
            width 750px
            max-width 100%
            margin-bottom 56px  
        

    .hero__scroll-down
        font-size 12px
        font-weight 600
        color #808080
        writing-mode vertical-lr
        position absolute
        bottom 10px
        left 20px
        
        @media (max-height 540px)
            display none
        
        @media (min-width 1024px)
            bottom 80px
            left 80px
            
        @media (min-width 1600px)
            left 100px
            font-size 14px
</style>